import { WebRTCPlayer } from "./WebRTCPlayer";

interface Props {
  streamName: string | null;
  label?: string;
  onDecodeError?: () => void;
  onTranscodeFailed?: () => void;
  paused?: boolean;
  playbackRate?: number;
  onTimeUpdate?: (elapsedSeconds: number) => void;
  onStreamEnded?: () => void;
}

export function PlaybackPlayer({
  streamName, label, onDecodeError, onTranscodeFailed,
  paused, playbackRate, onTimeUpdate, onStreamEnded,
}: Props) {
  return (
    <WebRTCPlayer
      streamName={streamName}
      label={label}
      showAudioToggle={true}
      onDecodeError={onDecodeError}
      onTranscodeFailed={onTranscodeFailed}
      connectingHint="Cargando grabacion..."
      paused={paused}
      playbackRate={playbackRate}
      onTimeUpdate={onTimeUpdate}
      onStreamEnded={onStreamEnded}
    />
  );
}
